// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"d4833200","513":"24cdf7ba","703":"d902ba1e","787":"e0130a4c"}[chunkId] + ".chunk.js";
};